var exports = {
  "DR": "Box_0__cxO0cR",
  "wy": "Box_1___Mug1A",
  "J5": "Octicon_0__Soxk7n",
  "GE": "AvatarStack__2Th2ie",
};

module.exports = exports;
